const branches = {
  branches: {
    pageHeader: 'Filiaalkantoren',
    addBranchOffice: '+Voeg filiaalkantoor toe',
    name: 'Naam',
    city: 'Stad',
    state: 'Regio/Provincie',
    country: 'Land',
    branches: 'Filialen',
    noBranchAvailable: '** Geen beschikbare Filialen **'
  }
};

export default branches;
